import React from 'react';
import ServiceDetailTemplate from '../Elements/ServiceDetailTemplate';

const bnrimg = require('../../images/pic3.jpg');
const productImg = require('../../images/reportes.png');

const ServiceDetailReports = () => (
    <ServiceDetailTemplate
        moduleKey="reportes"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default ServiceDetailReports;
